import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueAxios from "vue-axios";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import * as VueGoogleMaps from "vue2-google-maps";
import { io } from "socket.io-client";
import VueCookies from "vue-cookies";

import axios from "axios";
import { createInstance } from "./api/gateway.api";

Vue.config.productionTip = false;

require("moment/locale/de");
moment.locale("de");

Vue.use(VueMoment, { moment });
Vue.use(VueCookies);

const app = new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
});

setup().finally(() => app.$mount("#app"));

async function setup() {
    const config = await axios.get(window.location.origin + "/config.php");
    const host = config?.data?.api_host || process.env.VUE_APP_API_HOST;
    const api = await createInstance(host);

    Vue.use(VueAxios, api);
    Vue.use(VueGoogleMaps, { load: { key: store.state.auth.credentials?.google, libraries: "places" } });
    Vue.prototype.$io = (nsp) => io(host + nsp);
    if (!config) console.warn("config not found");

    if (process.env.NODE_ENV != "production") return;
    const pushManager = (await navigator.serviceWorker.ready).pushManager;
    const subscription = await pushManager.getSubscription();

    if (subscription != undefined) return;

    const _subscription = await pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: config?.data?.vapid_public || process.env.VUE_APP_VAPID_PUBLIC,
    });

    Vue.axios.post("/notification/subscribe", _subscription);
}
